module.exports = __webpack_public_path__ + "static/media/logo.d78f53d8.svg";